const emptyPerson = {
  personId: null,
  nr: null,
  gender: 'M',
  details: {},
  controlDetails: { language: 'fi' },
  nationalDetails: {},
  otherDetails: {},
  settings: {},
  employmentDetails: { personStatus: 'NOT_EMPLOYED' },
}

export default emptyPerson